import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHelperService } from '../http.service';
import { environment } from 'src/environments/environment';
import { UserDto } from 'src/app/types/dto/user.dto';
import { AuthService } from '../auth.service';
import { TimedCache } from '../timed-cache';


@Injectable({
    providedIn: 'root'
})
export class UserService {
    private http = inject(HttpClient);
    private httpHelper = inject(HttpHelperService);
    private auth = inject(AuthService);


    baseURL = environment.apiUrl + 'users/';

    private cachedCompUsers = new TimedCache<UserDto[]>()
    private cachedUsers = new TimedCache<UserDto>()

    getCurrCompUsers(userTypeId: number | undefined): Observable<UserDto[]> {
        const comp = this.auth.getCurrentCompany()
        const key = `${comp?.id ?? 0}_${userTypeId ?? 'all'}`
        let url = environment.apiUrl + 'companies/users';
        if (userTypeId !== null) {
            url += '?userTypeId';
        }

        return this.cachedCompUsers.get(key, () =>
            this.http.get<UserDto[]>(url, this.httpHelper.httpReadOnlyOptions)
        )
    }

    getUser(id: number): Observable<UserDto> {
        return this.cachedUsers.get(id, () =>
            this.http.get<UserDto>(this.baseURL + id, this.httpHelper.httpReadOnlyOptions)
        )
    }

    getUserByEmail(email: string) {
        return this.cachedUsers.get(email, () =>
            this.http.get<UserDto>(this.baseURL + email, this.httpHelper.httpReadOnlyOptions)
        )
    }

}
